import React from 'react';
import { Box, Typography, Paper, Chip } from '@mui/material';
import { FileText } from 'lucide-react';

interface ReportCardProps {
  report: {
    report_id?: string;
    title?: string;
    report_type?: string;
    summary?: Record<string, unknown>;
    generated_at?: string;
  };
}

const ReportCard: React.FC<ReportCardProps> = ({ report }) => {
  return (
    <Paper variant="outlined" sx={{ p: 1.5, mb: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <FileText size={16} />
        <Typography variant="subtitle2" fontWeight={600}>
          {report.title || 'Generated Report'}
        </Typography>
        {report.report_type && (
          <Chip label={report.report_type} size="small" color="primary" variant="outlined" />
        )}
      </Box>
      {report.generated_at && (
        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 0.5 }}>
          Generated: {new Date(report.generated_at).toLocaleString()}
        </Typography>
      )}
      {report.summary && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
          {Object.entries(report.summary).map(([key, val]) =>
            val != null ? (
              <Chip
                key={key}
                label={`${key.replace(/_/g, ' ')}: ${val}`}
                size="small"
                variant="outlined"
                sx={{ fontSize: '0.7rem' }}
              />
            ) : null
          )}
        </Box>
      )}
      <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: 'block' }}>
        Available in the Reports section for download.
      </Typography>
    </Paper>
  );
};

export default ReportCard;
